import LoadingSkeleton from "components/ui/Skeleton";

export const CardSkeleton = () => {
  return (
    <div className="p-2">
      <div className="flex gap-2">
        <LoadingSkeleton className="w-16 h-24 rounded-lg shrink" />
        <div className="flex justify-between grow">
          <div className="flex grow flex-col gap-2 justify-between">
            <div className="flex flex-col gap-2">
              <LoadingSkeleton className="h-4 w-1/2 rounded-md mt-2" />
              <LoadingSkeleton className="h-4 w-1/3 rounded-md" />
            </div>
            <LoadingSkeleton className="h-3 w-1/3 rounded-md" />
          </div>
          <LoadingSkeleton className="h-12 w-20 rounded-md self-end" />
        </div>
      </div>
    </div>
  );
};

export default function CardCollectionSkeleton() {
  return (
    <>
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
    </>
  );
}
